import styled from 'styled-components';
import { Table } from 'react-bootstrap';

export const TableWrapper = styled(Table)`
    & > thead > tr > th {
        text-align: center;
        background-color: #122666;
        color: white;
    }

    & > tbody > tr > td {
        vertical-align: middle !important;
        text-align: center;
    }

    & > tbody > tr > td > .form-group {
        margin-bottom: 0px;
    }
`;

export const GridWrapper = styled.div<{ width?: string, height?: string, headerBgColor?: string, headerFontColor?: string, headerFontWeight?: number }>`
    width: ${p => p.width ? p.width : '87%'};
    height: ${p => p.height ? p.height : '74vh'};

    .action-menu {
        overflow: visible;
        // border-bottom: none;
        line-height: 25px;
        // border-color: #ccc;
        display: flex;
        align-items: center;
    }

    .action-menu.ag-cell-focus {
        // border-top: 1px solid #ccc !important;
        // border-right: 1px solid white !important;
        // border-bottom: 1px solid white !important;
        // border-left: 1px solid #ccc !important;
    }

    .ag-header {
        background-color: ${p => p.headerBgColor ? p.headerBgColor : '#133366'};
        color: ${p => p.headerFontColor ? p.headerFontColor : 'white'} !important;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
        font-weight: ${p => p.headerFontWeight ? p.headerFontWeight : 400};
    }

    .ag-header-cell::after {
        border-right: 1px solid #ccc;
        content: " ";
        height: 16px;
        margin-top: 4px;
        position: absolute;
        text-indent: -2000px;
        top: 0;
        right: 0;
    }

    .ag-body-viewport {
        border-left: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
    }

    .ag-row {
        z-index: 0;
    }

        .ag-row.ag-row-hover {
        background-color: #eaf2fa;
    }

    .ag-row.ag-row-focus {
        z-index: 1;
    }

    .list-header {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: 4px;
    }

    .list-cell {
        text-align: center;
        //line-height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .list-cell-full {
        text-align: center;
        //line-height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
    }

    .list-cell-full > .ag-react-container {
        width: 100%;
    }

    .list-cell-left {
        text-align: left;
        // line-height: 28px;
        display: flex;
        align-items: center;
    }

    .list-cell-dropdown {
        // line-height: 28px;
        display: flex;
        align-items: center;
        // padding-top: 3px;
        justify-content: center;
    }

    .customSortUpLabel > span,
    .customSortDownLabel > span {
        margin-left: 3px !important;
    }
`;

